import { Box } from '@material-ui/core';
import { SpecialMessageParser } from '@src/logic/specialmessageprocessing';
import { MediaType } from '@src/model/frontendmodel';
import { ChatTray } from '@src/types/chats';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ErrorOutlineIcon } from './SvgIcons';
import IconWrapper from '../Common/IconWrapper';
import RenderMarkdown from '../RTEditor/RenderMarkdown';

const LastMessagePreview: React.FC<{ chat: ChatTray }> = ({
  chat: { lastMessage },
}) => {
  const { formatMessage } = useIntl();

  const NoDeliveriedMessage = useMemo(
    () => (
      <Box component="span" display="flex" alignItems="center" gridGap={2}>
        <IconWrapper fontSize={14}>{ErrorOutlineIcon}</IconWrapper>
        {formatMessage({ id: 'ChatEvent.ErrorMsgNotDelivered' })}
      </Box>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (lastMessage?.deliveryFailed) return NoDeliveriedMessage;

  if (lastMessage?.mediaType && lastMessage?.mediaType !== MediaType.TEXT) {
    return formatMessage({
      id: `MediaType.${lastMessage?.mediaType || 'DEFAULT'}`,
      defaultMessage:
        lastMessage?.mediaType === MediaType.PRODUCT_OVERVIEW
          ? formatMessage({ id: 'Shopify.last.received.msg.label' })
          : 'Media',
    }) as unknown as React.ReactElement;
  }

  if (lastMessage?.text) {
    const notDeliveredNotifData =
      SpecialMessageParser.isMsgNotDeliveredNotification(lastMessage.text);

    if (notDeliveredNotifData !== null) return NoDeliveriedMessage;
  }

  return <RenderMarkdown markdown={lastMessage?.text ?? ''} />;
};

export default LastMessagePreview;
